<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" *ngIf="kivalasztott">
      <ion-button (click)="vissza()">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{kivalasztott ? stripElotagok(kivalasztott.azonosito) + ' v' + kivalasztott.verzio : 'Nyomtatványok'}}</ion-title>
    <ion-buttons slot="end" *ngIf="kivalasztott">
      <ion-button (click)="importXmlTrigger()" color="medium" fill="outline">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
        XML
      </ion-button>
      <ion-button (click)="importEnykTrigger()" color="medium" fill="outline">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
        ENYK
      </ion-button>
      <ion-button (click)="importTxtTrigger()" color="medium" fill="outline">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
        TXT
      </ion-button>
      <ion-button (click)="letoltPdf()" color="tertiary">
        <ion-icon slot="start" name="document-outline"></ion-icon>
        PDF
      </ion-button>
      <ion-button (click)="letolt()" color="success">
        <ion-icon slot="start" name="download-outline"></ion-icon>
        Letöltés
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- LISTA NÉZET -->
  <ng-container *ngIf="!kivalasztott">
    <ion-card *ngIf="!fajlSablonok.length">
      <ion-card-content>Nincsenek elérhető sablonok.</ion-card-content>
    </ion-card>

    <ion-list>
      <ion-item button *ngFor="let s of fajlSablonok" (click)="kivalaszt(s)" detail="true">
        <ion-icon slot="start" name="document-text-outline" color="primary"></ion-icon>
        <ion-label>
          <h2><strong>{{stripElotagok(s.azonosito)}}</strong> <ion-badge color="medium">v{{s.verzio}}</ion-badge></h2>
          <p *ngIf="s.adozoNev">Példa: {{s.adozoNev}}</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>

  <!-- KITÖLTŐ NÉZET -->
  <ng-container *ngIf="kivalasztott">
    <input #xmlFileInput type="file" accept=".xml" style="display:none" (change)="importXml($event)">
    <input #enykFileInput type="file" accept=".enyk" style="display:none" (change)="importEnyk($event)">
    <input #txtFileInput type="file" accept=".txt" style="display:none" (change)="importTxt($event)">
    <section class="anyak-panel">
      <header class="anyak-header">
        <div>
          <h2>{{stripElotagok(kivalasztott.azonosito)}}</h2>
          <p>{{mezok.length}} mező, ANyK-szerű automatikus csoportosítás</p>
        </div>
      </header>

      <!-- Forma-példány kiválasztó (dropdown) + kötegelt gombok -->
      <div class="instancia-row" *ngIf="lapInstanciak.length > 1 || kotegeltAzonosito">
        <ion-select
          *ngIf="lapInstanciak.length > 1"
          interface="popover"
          class="instancia-select"
          label="Nyomtatvány:"
          label-placement="start"
          [value]="aktivLap"
          (ionChange)="instanciaValtott($event.detail.value)">
          <ion-select-option *ngFor="let lap of lapok" [value]="lap">{{lap}}</ion-select-option>
        </ion-select>
        <ng-container *ngIf="kotegeltAzonosito">
          <ion-button size="small" color="danger" fill="outline"
            *ngIf="lapTorolheto(aktivLap)"
            (click)="lapTorol(aktivLap)">
            <ion-icon slot="start" name="trash-outline"></ion-icon>
            Törlés
          </ion-button>
          <ion-button size="small" color="primary" (click)="lapHozzaad()">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
            + {{kotegeltAzonosito}}
          </ion-button>
        </ng-container>
      </div>

      <!-- Oldalak a kiválasztott nyomtatványon belül -->
      <ion-segment *ngIf="oldalakAktivInstancian.length > 1" [(ngModel)]="aktivOldalCim" scrollable class="anyak-segment">
        <ion-segment-button *ngFor="let cim of oldalakAktivInstancian" [value]="cim">
          <ion-label>{{cim}}</ion-label>
        </ion-segment-button>
      </ion-segment>

      <!-- Mező input widget sablon (újrahasználható) -->
      <ng-template #mezoWidget let-m="m">
        <ion-checkbox
          *ngIf="isCheckbox(m)"
          [checked]="m.ertek === 'X'"
          [disabled]="isReadonly(m)"
          (ionChange)="checkboxValtozott(m, $event.detail.checked)"
          labelPlacement="end"
        >Jelölve</ion-checkbox>

        <div *ngIf="isKockas(m)" class="kockas-sor">
          <ion-input
            *ngFor="let ch of kockaErtekek(m); let i = index"
            [value]="ch"
            maxlength="1"
            class="kocka-input"
            [readonly]="isReadonly(m)"
            (ionInput)="kockaValtozott(m, i, $any($event.target).value || '')"
          ></ion-input>
        </div>

        <ion-input
          *ngIf="!isCheckbox(m) && !isKockas(m) && !isDropdown(m)"
          [(ngModel)]="m.ertek"
          class="anyak-text"
          [readonly]="isReadonly(m)"
          [title]="mezoSugo(m)"
          [placeholder]="mezoLabel(m)"
          (ngModelChange)="mezoValtozott()"
        ></ion-input>

        <ion-select
          *ngIf="isDropdown(m)"
          [(ngModel)]="m.ertek"
          interface="popover"
          class="anyak-select"
          [disabled]="isReadonly(m)"
          [title]="mezoSugo(m)"
          [placeholder]="mezoLabel(m)"
          (ngModelChange)="mezoValtozott()"
        >
          <ion-select-option *ngFor="let opcio of getDropdownOpciok(m)" [value]="opcio.value">
            {{opcio.label}}
          </ion-select-option>
        </ion-select>

        <div *ngIf="mezoHibas(m)" style="margin-top:4px;color:var(--ion-color-danger);font-size:0.82em;">
          {{ mezoHibak(m).join(' ') }}
        </div>
      </ng-template>

      <!-- LAYOUT NÉZET: blokkok → sorok → mezők (egymás mellett) -->
      <ng-container *ngIf="viewBlokkjai.length">
        <div class="anyak-blokk" *ngFor="let blokk of viewBlokkjai">
          <div class="anyak-blokk-cim" *ngIf="blokk.cim">{{blokk.cim}}</div>
          <div class="anyak-sor" *ngFor="let sor of blokk.sorok">
            <div class="anyak-col" *ngFor="let m of sor.mezok"
                 [style.flex]="m.szeles" [ngClass]="mezotipusClass(m)">
              <div class="anyak-col-label">{{mezoLabel(m)}}</div>
              <div class="anyak-col-input">
                <ng-container *ngTemplateOutlet="mezoWidget; context: {m: m}"></ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Mezők, amelyek nincsenek a layoutban – elrejtve -->
        <ng-container *ngIf="false && viewMezokNincsLayout.length">
          <div class="anyak-blokk anyak-blokk--egyeb">
            <div class="anyak-blokk-cim">Egyéb mezők</div>
            <div class="anyak-sor" *ngFor="let m of viewMezokNincsLayout">
              <div class="anyak-col" [style.flex]="1" [ngClass]="mezotipusClass(m)">
                <div class="anyak-col-label">{{mezoLabel(m)}} <span class="anyak-eazon-chip">{{m.eazon}}</span></div>
                <div class="anyak-col-input">
                  <ng-container *ngTemplateOutlet="mezoWidget; context: {m: m}"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- EGYSZERŰ NÉZET: nincs layout, lapos lista -->
      <ng-container *ngIf="!viewBlokkjai.length">
        <div class="anyak-table">
          <div class="anyak-row" *ngFor="let m of mezokAktivLapon" [ngClass]="mezotipusClass(m)">
            <div class="anyak-meta">
              <div class="anyak-eazon">{{m.eazon}}</div>
              <div class="anyak-label">{{mezoLabel(m) || 'Ismeretlen mezőnév'}}</div>
              <div class="anyak-tipus">{{mezotipusSzoveg(m)}}</div>
            </div>
            <div class="anyak-input">
              <ng-container *ngTemplateOutlet="mezoWidget; context: {m: m}"></ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="anyak-actions">
        <ion-button (click)="letoltPdf()" color="tertiary" fill="outline">
          <ion-icon slot="start" name="document-outline"></ion-icon>
          Letöltés PDF-ként
        </ion-button>
        <ion-button (click)="letolt()" color="success">
          <ion-icon slot="start" name="download-outline"></ion-icon>
          Letöltés XML-ként
        </ion-button>
      </div>
    </section>
  </ng-container>

</ion-content>
